/**
 * Created by Omar Alejandr Leonor Avalos on 2017-06-10.
 * Exporting valid types to build forms.
 */
export const AUTOCOMPLETE = 'autocomplete';
export const TEXT = 'text';
export const DATE = 'date';
export const SELECT = 'select';
export const FILE = 'file';
export const REMOTE_AUTOCOMPLETE = 'remoteAutocomplete';



// WEBPACK FOOTER //
// ./components/data-containers/formBuilder/types.js